import styled from 'styled-components';

export const Root = styled.div`
	display: grid;
	width: 100%;
	grid-gap: 25px;
	grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));

	@media (min-width: 993px) {
		${({ $twoColumn }) => !$twoColumn && 'grid-template-columns: repeat(3, 1fr)'};
	}

	@media (min-width: 1200px) {
		grid-template-columns: repeat(4, 1fr);
	}
`;


